import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineRewindClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.63}
      d="M10 5.945V10h2.896"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.63}
      d="M3.047 7.104A7.532 7.532 0 0 1 17.53 10a7.53 7.53 0 0 1-14.858 1.738"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.63}
      d="M2.47 4.208v2.896h2.896"
    />
  </svg>
);
export default SvgStreamlineRewindClock;
